import React from 'react';
import { Switch, Route, useLocation } from 'react-router';
import Routes from 'routes';
import FsCenterBoxLayout from 'ui-elements/layouts/FsCenterBoxLayout/FsCenterBoxLayout';
import Register from './Pages/Register';
import Login from './Pages/Login';
import RegisterFromInvitation from './Pages/RegisterFromInvitation';
import ResetPassword from './Pages/ResetPassword';

const Registration: React.FC = () => {
  const { pathname } = useLocation();
  const isLoginPath = pathname.includes(Routes.LOGIN);

  return (
    <FsCenterBoxLayout withLogin={!isLoginPath}>
      <Switch>
        <Route path={Routes.LOGIN_WITH_PARAMETERS} exact component={Login} />
        <Route path={Routes.REGISTER} exact component={Register} />
        <Route
          path={Routes.REGISTER_FROM_INVITATION_WITH_PARAMETERS}
          exact
          component={RegisterFromInvitation}
        />
        <Route
          path={Routes.RESET_PASSWORD_WITH_PARAMETERS}
          exact
          component={ResetPassword}
        />
      </Switch>
    </FsCenterBoxLayout>
  );
};

export default Registration;
